/*
 * @Description:
 * @Date: 2020-07-19 14:52:27
 */

import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';

// import { blobToDataURI, getNetFile } from '@/tools';
// import { resolve } from 'core-js/fn/promise';
// const download = require('downloadjs');

const PDF_PAGE_HEIGHT = (1200 / 592.28) * 841.89;

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

// async function loadFile() {
//   let data = await getNetFile(
//     'http://cdn.yxvzb.com/WEB/SaaS/images/bi/watermark.png'
//   );
//   mark = await blobToDataURI(data);
// }

function getStyle(obj, attr) {
  let value = 0;
  try {
    if (obj.currentStyle) {
      value = parseInt(obj.currentStyle[attr]);
    } else {
      value = parseInt(document.defaultView.getComputedStyle(obj, null)[attr]);
    }
  } catch (err) {
    console.error(err);
  }
  return value;
}

function loadImage(src) {
  return new Promise(resolve => {
    const img = new Image();
    img.src = src;
    img.setAttribute('crossOrigin', 'anonymous');
    img.onload = function() {
      resolve(this);
    };
  });
}

function compose(canvas, img) {
  let { width, height } = canvas;
  // 合成
  let composeCanvas = document.createElement('canvas');
  let composeCtx = composeCanvas.getContext('2d');
  composeCanvas.width = width;
  composeCanvas.height = height;
  composeCtx.drawImage(canvas, 0, 0);
  // 平铺水印
  let bg = composeCtx.createPattern(img, 'repeat');
  composeCtx.fillStyle = bg;
  composeCtx.fillRect(0, 0, width, height);
  return composeCanvas.toDataURL('image/jpeg', 1.0);
}

/**
 * @param  ele          要生成 pdf 的DOM元素（容器）
 * @param  markImg      水印
 * @param  type         生成类型 pdf png
 * @param  pdf          pdf 实例
 * @return dataURL      生成图片
 * */
const toCanvas = (elDom, markImg, type, pdf) => {
  // todo 独占一页的pdf 白色好看一点
  let backgroundColor = type === 'pdf' ? '#fff' : '#F8FBFF';
  return new Promise(async resolve => {
    html2canvas(elDom, {
      dpi: 300,
      useCORS: true,
      width: elDom.offsetWidth,
      height: elDom.offsetHeight,
      scale: 1,
      x: 0,
      y: 0,
      async: true,
      logging: false,
      backgroundColor,
      foreignObjectRendering: true,
      removeContainer: true
    }).then(canvas => {
      let composeData = compose(canvas, markImg);
      // download(composeData, 'aa');
      let contentWidth = canvas.width;
      let contentHeight = canvas.height;
      //一页pdf显示html页面生成的canvas高度;
      let pageHeight = (contentWidth / 592.28) * 841.89;
      //未生成pdf的html页面高度
      let leftHeight = contentHeight;
      //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      let imgWidth = 592.28;
      let imgHeight = (592.28 / contentWidth) * contentHeight;
      let position = 0;
      if (type === 'pdf') {
        // let pdfX = ((contentWidth + 10) / 2) * 0.75;
        // let pdfY = ((contentHeight + 500) / 2) * 0.75; // 500为底部留白
        // let imgX = pdfX;
        // let imgY = (contentHeight / 2) * 0.75; //内容图片这里不需要留白的距离
        // 一页打印
        // let pdf = new JsPDF('', 'pt', [pdfX, pdfY]);
        // pdf.addImage(composeData, 'JPEG', 0, 0, imgX, imgY);

        // 分页打印
        if (leftHeight < pageHeight) {
          pdf.addImage(composeData, 'JPEG', 7.5, 0, imgWidth, imgHeight);
          // pdf.addImage(markImg, 'PNG', 0, 0, 595.28, 841.89); // 添加水印
        } else {
          // 分页
          while (leftHeight > 0) {
            pdf.addImage(composeData, 'JPEG', 0, position, imgWidth, imgHeight);
            // pdf.addImage(markImg, 'PNG', 0, 0, 595.28, 841.89); // 添加水印
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 100) {
              pdf.addPage();
            }
          }
        }
      }
      resolve(composeData);
    });
  });
};

const oldHtml2NewHtml = (elDomArr, notCenter, isPdf) => {
  const dealDom = document.getElementById('bi-export-cache');
  const newDom = document.createElement('div');
  const width = 1200;
  const height = (width / 592.28) * 841.89;
  newDom.style =
    'width: 920px;overflow: hidden;margin: auto;transform-origin: 50% 0;';

  elDomArr.reduce((pre, cur) => {
    const { elDom, y = 0 } = cur;
    const cloneElDom = elDom.cloneNode(true);
    // x > 0 && (cloneElDom.style.marginLeft = `${x}px`);
    isPdf && y > 0 && (cloneElDom.style.marginTop = `${y}px`);
    pre.appendChild(cloneElDom);
    return pre;
  }, newDom);
  if (isPdf) {
    const newDomBox = document.createElement('div');
    if (notCenter) {
      newDomBox.style = `width: ${width}px;height:${height}px;overflow:hidden;`;
    } else {
      newDomBox.style = `width: ${width}px;height:${height}px;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;`;
    }
    newDomBox.appendChild(newDom);
    dealDom.appendChild(newDomBox);
    let { offsetHeight } = newDom;
    const scale = height / offsetHeight;
    if (scale < 1) {
      // newDom.style.transform = `scale(${scale})`;
      newDom.style.zoom = scale;
    }
  } else {
    dealDom.appendChild(newDom);
  }
  const { offsetLeft, offsetTop } = dealDom;
  offsetLeft > 0 && (dealDom.style.marginLeft = `-${offsetLeft}px`);
  offsetTop > 0 && (dealDom.style.marginTop = `-${offsetTop}px`);
};

const dealDomFn = doms => {
  const arrTest = [];
  const loopDealDom = (doms, index) => {
    const dom = doms[index].cloneNode(true);
    let domArr = [dom];
    let { offsetHeight } = doms[index];
    let flag = true;
    while (
      flag &&
      PDF_PAGE_HEIGHT - offsetHeight > -200 &&
      index < doms.length - 1
    ) {
      domArr.push(doms[++index].cloneNode(true));
      offsetHeight += doms[index].offsetHeight;
      if (PDF_PAGE_HEIGHT - offsetHeight < -200) {
        flag = false;
        domArr = domArr.slice(0, -1);
        offsetHeight -= doms[index].offsetHeight;
        index--;
      }
    }
    arrTest.push([
      {
        elDom: domArr.reduce((pre, cur) => {
          pre.appendChild(cur);
          return pre;
        }, document.createElement('div'))
        // y: (PDF_PAGE_HEIGHT - offsetHeight) / 2
      }
    ]);
    if (index < doms.length - 1) {
      loopDealDom(doms, index + 1);
    }
  };
  loopDealDom(doms, 0);
  return arrTest;
};

/**
 * @description: 生成内容，整张图片使用toCanvas返回值，pdf使用方法内的实例
 * @param {String} elName 元素id或者class 如果多个则都单独占一页，一个则按内容分页
 * @param {String} type pdf png
 * @param {String} fileName 文件名
 * @return {File} 文件
 */
const generate = async (elName = '.bi-export-item', type, fileName) => {
  document.getElementById('bi-export-cache').innerHTML = '';
  document.getElementById('bi-export-cache').style =
    'width:1200px;position:fixed;z-index:-2;transform-origin: 0 0;';
  // 解决出现横向滚动条内容被截取的情况
  document.getElementsByTagName('html')[0].scrollTo(0, 0);
  const pdf = new JsPDF('', 'pt', 'a4');
  const els = document.querySelectorAll(elName);
  const { childNodes } = els[0];
  const [
    logoDom,
    titleDom,
    combinationDom,
    itemDoms,
    footerDom
  ] = childNodes[0].children;
  const markImg = await loadImage(
    'http://cdn.yxvzb.com/WEB/SaaS/images/bi/watermark.png?v=3&time=' +
      new Date().getTime()
  );

  let dataURL = null;
  const logoDomHeight = logoDom.offsetHeight + getStyle(logoDom, 'paddingTop');
  const contentDomArr = [
    [
      {
        elDom: logoDom
      },
      {
        elDom: titleDom,
        y:
          (PDF_PAGE_HEIGHT -
            titleDom.offsetHeight -
            getStyle(titleDom, 'paddingTop')) /
            2 -
          logoDomHeight -
          20
      }
    ],
    ...dealDomFn([combinationDom, ...itemDoms.childNodes, footerDom])
  ].reduce((pre, cur, index) => {
    pre.push({
      domInfo: cur,
      notCenter: index == 0,
      page: index + 1,
      beforePage: index
    });
    return pre;
  }, []);
  contentDomArr.forEach(({ domInfo, notCenter }) => {
    oldHtml2NewHtml(domInfo, notCenter, type === 'pdf');
  });
  dataURL = await toCanvas(
    document.getElementById('bi-export-cache'),
    markImg,
    type,
    pdf
  );
  if (type === 'pdf') {
    dataURL = pdf.output('datauristring');
  }
  document.getElementById('bi-export-cache').innerHTML = '';
  return Promise.resolve(dataURLtoFile(dataURL, fileName));
};

export default {
  generate
};
